import {
  IconAirplane,
  IconLocation,
  IconOffersMobile,
  IconTime,
  IconTrain,
  IconGeolocation,
  IconHotel,
  IconGrid,
  IconLocationServices,
} from '@americanexpress/dls-icons';

export const ADDRESS_KEY = 'ADDRESS';
export const AIRPORT_KEY = 'AIRPORT';
export const FLIGHT_KEY = 'FLIGHT';
export const PACKAGE_KEY = 'PACKAGE';
export const HOTEL_KEY = 'HOTEL';
export const CITY_KEY = 'CITY';
export const CAR_KEY = 'CAR';
export const POI_KEY = 'POI';
export const NEIGHBORHOOD_KEY = 'NEIGHBORHOOD';
export const REGION_KEY = 'REGION';
export const TRAIN_STATION_KEY = 'TRAINSTATION';
export const THC_KEY = 'THC';
export const FHR_KEY = 'FHR';
export const AIR_KEY = 'AIR';
export const RECENT_SEARCHES_KEY = 'RECENTSEARCHES';
export const CHANNEL_NAME = 'TLSONLINE';
export const RECENT_SEARCH_FEEDBACK_AIR = 'AIR_SEARCH_FB';
export const RECENT_SEARCH_FEEDBACK_HOTEL = 'HTL_SEARCH_FB';
export const RECENT_SEARCH_EVENT_TYPE = 'GLOBAL_ONLINE_TLSONLINE_FEEDBACK';

export const RECENT_SEARCHES = {
  key: RECENT_SEARCHES_KEY,
  iconNode: IconTime,
  copy: 'recentSearches',
};

export const AIRPORT = {
  key: AIRPORT_KEY,
  iconNode: IconAirplane,
  copy: 'airports',
};

export const HOTEL = {
  key: HOTEL_KEY,
  iconNode: IconHotel,
  copy: 'hotel',
};

export const CITY = {
  key: CITY_KEY,
  iconNode: IconLocation,
  copy: 'cities',
};

export const POI = {
  key: POI_KEY,
  iconNode: IconGeolocation,
  copy: 'points_of_interest',
};

export const NEIGHBORHOOD = {
  key: NEIGHBORHOOD_KEY,
  iconNode: IconGrid,
  copy: 'neighborhood',
};

export const REGION = {
  key: REGION_KEY,
  iconNode: IconOffersMobile,
  copy: 'region',
};

export const ADDRESS = {
  key: ADDRESS_KEY,
  iconNode: IconLocationServices,
  copy: 'address',
};

export const TRAIN_STATION = {
  key: TRAIN_STATION_KEY,
  iconNode: IconTrain,
  copy: 'train',
};

export const SEARCH_TYPES = {
  FLIGHT: {
    key: FLIGHT_KEY,
    priority:
    [RECENT_SEARCHES, AIRPORT, CITY, NEIGHBORHOOD, HOTEL, REGION, POI, TRAIN_STATION, ADDRESS],
  },
  PACKAGE: {
    key: FLIGHT_KEY,
    priority:
      [RECENT_SEARCHES, AIRPORT, CITY, NEIGHBORHOOD, HOTEL, REGION, POI, TRAIN_STATION, ADDRESS],
  },
  HOTEL: {
    key: HOTEL_KEY,
    priority:
    [RECENT_SEARCHES, CITY, AIRPORT, HOTEL, NEIGHBORHOOD, REGION, POI, TRAIN_STATION, ADDRESS],
  },
  CAR: {
    key: CAR_KEY,
    priority: [AIRPORT, CITY, ADDRESS, TRAIN_STATION, NEIGHBORHOOD, HOTEL, REGION, POI],
  },
  THC: {
    key: THC_KEY,
    priority: [CITY, HOTEL, REGION],
  },
  FHR: {
    key: FHR_KEY,
    priority: [CITY, HOTEL, REGION],
  },
};
